

document.addEventListener("DOMContentLoaded", function(){



/* ---------------- ELEMENTS ---------------- */

const modal = document.getElementById("profileModal");
const festivalModal = document.querySelector(".festival-modal");

const createBtn = document.querySelector(".create-profile-btn");
const closeBtn = document.querySelector(".modal-close");
const overlay = document.querySelector(".modal-overlay");

/* Festival Step */
const otherCheckbox = document.getElementById("otherFestival");
const festivalStep = document.getElementById("festivalStep");
const otherStep = document.getElementById("otherFestivalStep");
const nextBtn = document.getElementById("festivalNextBtn");
const backBtn = document.getElementById("backBtn");
const otherInput = document.getElementById("otherFestivalInput");

/* Color Step */
const festivalColorStep = document.getElementById("festivalColorStep");
const colorBackBtn = document.getElementById("colorBackBtn");
const colorNextBtn = document.querySelector("#festivalColorStep .festival-next");

/* Accessories Step */
const accessoriesStep = document.getElementById("festivalAccessoriesStep");
const accessoryBackBtn = document.getElementById("accessoryBackBtn");
const accessoryNextBtn = document.getElementById("accessoryNextBtn");

/* Marital Step */
const maritalStep = document.getElementById("festivalMaritalStep");
const maritalBackBtn = document.getElementById("maritalBackBtn");
const maritalNextBtn = document.getElementById("maritalNextBtn");

/* Date */
const dayDateStep = document.getElementById("festivalDateStep");

/* Anniversary */
const anniversaryBlock = document.getElementById("anniversaryBlock");

/* Inputs */
const dobInput = document.getElementById("dobInput");
const anniversaryInput = document.getElementById("anniversaryInput");
const locationSelect = document.getElementById("locationSelect");

const dateNextBtn = document.getElementById("dateNextBtn");
const dateBackBtn = document.getElementById("dateBackBtn");

/* Shop */
const shopStep = document.getElementById("festivalShopStep");
const shopNextBtn = document.getElementById("shopNextBtn");
const shopBackBtn = document.getElementById("shopBackBtn");

/* Usually Shop Step */
const usuallyShopStep = document.getElementById("usuallyShopStep");
const usuallyOptions = document.querySelectorAll('#usuallyShopStep input[type="radio"]');
const usuallyNextBtn = document.getElementById("usuallyNextBtn");
const usuallyBackBtn = document.getElementById("usuallyBackBtn");

/* Silhouette */
const silhouetteStep = document.getElementById("festivalSilhouetteStep");
const silhouetteNextBtn = document.querySelector("#festivalSilhouetteStep .silhouette-next");
const silhouetteBackBtn = document.getElementById("silhouetteBackBtn");

/* Final */
const festivalCompleteStep = document.getElementById("festivalCompleteStep");

/* Start Shopping */
const startShoppingBtn = document.getElementById("startShoppingBtn");

/* Input Groups */
const allCheckboxes = document.querySelectorAll('#festivalStep input[type="checkbox"]');
const colorOptions = document.querySelectorAll('#festivalColorStep input[type="radio"], #festivalColorStep input[type="checkbox"]');
const accessoryOptions = document.querySelectorAll('#festivalAccessoriesStep input[type="radio"]');
const maritalOptions = document.querySelectorAll('#festivalMaritalStep input[type="radio"]');
const shopOptions = document.querySelectorAll('#festivalShopStep input[type="radio"], #festivalShopStep input[type="checkbox"]');
const silhouetteOptions = document.querySelectorAll('#festivalSilhouetteStep input[type="radio"]');

/*loader*/
const profileLoader = document.getElementById("profileLoader");



const dobField = dobInput.closest(".date-field");
const dobWrap = dobField.querySelector(".date-input-wrap");

const anniversaryField = anniversaryInput.closest(".date-field");
const anniversaryWrap = anniversaryField.querySelector(".date-input-wrap");

const locationField = locationSelect.closest(".date-field");
const locationWrap = locationField.querySelector(".date-input-wrap");


/* ---------------- NEW: STEP CONTROLLER (SAFE ADDITION) ---------------- */

const steps = [
  festivalStep,
  otherStep,
  festivalColorStep,
  accessoriesStep,
  maritalStep,
  dayDateStep,
  shopStep,
  silhouetteStep,
  usuallyShopStep,
  festivalCompleteStep
];

function showStep(activeStep){
  steps.forEach(step=>{
    if(step){
      step.style.display = (step === activeStep) ? "block" : "none";
    }
  });
}

/* ---------------- MODAL CLOSE (FIXED) ---------------- */

closeBtn?.addEventListener("click", () => {
  modal.classList.remove("active");
  document.body.classList.remove("modal-open");

  setTimeout(() => {
    resetAll();
  }, 200); // small delay fixes UI glitch
});

overlay?.addEventListener("click", () => {
  modal.classList.remove("active");
  document.body.classList.remove("modal-open");

  setTimeout(() => {
    resetAll();
  }, 200);
});




/* ---------------- ERROR CREATOR ---------------- */

function createError(el, text, customContainer = null) {
  let msg = document.createElement("p");
  msg.textContent = text;
  msg.classList.add("error-message");
  msg.style.display = "none";

  if (customContainer) {
    customContainer.appendChild(msg);
  } else {
    el?.parentNode.insertBefore(msg, el);
  }

  return msg;
}

/* ---------------- ERROR MESSAGES ---------------- */

let festivalError = createError(nextBtn,"Please select festival");
let colorError = createError(colorNextBtn,"Please select color");
let accessoryError = createError(accessoryNextBtn,"Please select accessory type");
let maritalError = createError(maritalNextBtn,"Please select marital status");
let dobError = createError(null, "Please select your date of birth", dobWrap.parentNode);
dobWrap.insertAdjacentElement("afterend", dobError);

let anniversaryError = createError(null, "Please select anniversary date", anniversaryWrap.parentNode);
anniversaryWrap.insertAdjacentElement("afterend", anniversaryError);

let locationError = createError(null, "Please select your location", locationWrap.parentNode);
locationWrap.insertAdjacentElement("afterend", locationError);
let shopError = createError(shopNextBtn,"Please select where you usually shop");
let silhouetteError = createError(silhouetteNextBtn,"Please select silhouette");
let usuallyError = createError(usuallyNextBtn,"Please select who usually shops");

/* ---------------- MODAL OPEN ---------------- */


createBtn?.addEventListener("click", () => {

  console.log("Customer Data:", window.customerData);

  if (window.customerData && window.customerData.loggedIn) {

    try {
      resetAll(); // reset safely
    } catch(e){
      console.warn("Reset error:", e);
    }

    modal.classList.add("active");
    document.body.classList.add("modal-open");

  } else {

    sessionStorage.setItem("openProfileAfterLogin", "yes");
    document.querySelector('.header__icon--account')?.click();

  }

});



/* ---------------- RESET (ENHANCED ONLY) ---------------- */

function resetAll(){

  /* KEEP YOUR ORIGINAL RESET */
  document.querySelectorAll("input").forEach(input=>{
    if(input.type === "checkbox" || input.type === "radio"){
      input.checked = false;
    }else{
      input.value = "";
    }
  });

  locationSelect.value="";
  if(otherInput) otherInput.value="";

  /* NEW: destroy flatpickr safely */
  [dobInput, anniversaryInput].forEach(input=>{
    if(input && input._flatpickr){
      input._flatpickr.destroy();
    }
  });

  /* NEW: reset anniversary */
  anniversaryBlock.style.display = "none";

  /* NEW: clear colors safely */
  const dynamicColors = document.getElementById("dynamicColorList");
  if(dynamicColors){
    dynamicColors.innerHTML = "";
  }

  hideErrors();

  /* IMPORTANT: force clean first step */
  showStep(festivalStep);

  /* keep your wrapper visible */
  festivalModal.style.display="block";
}

function hideErrors(){
  festivalError.style.display="none";
  colorError.style.display="none";
  accessoryError.style.display="none";
  maritalError.style.display="none";
  dobError.style.display="none";
  anniversaryError.style.display="none";
  locationError.style.display="none";
  shopError.style.display="none";
  silhouetteError.style.display="none";
  usuallyError.style.display="none";
}



/* ---------------- EXISTING FLOW ---------------- */





nextBtn.addEventListener("click",()=>{
  let selected=[...allCheckboxes].some(cb=>cb.checked);
  if(!selected){ festivalError.style.display="block"; return; }

  festivalError.style.display="none";

  /* LOAD COLORS BASED ON FESTIVAL */
  loadFestivalColors();

  festivalModal.style.display="none";
  festivalColorStep.style.display="block";
});

colorNextBtn?.addEventListener("click",()=>{

  const colorOptions = document.querySelectorAll(
    '#festivalColorStep input[type="checkbox"], #festivalColorStep input[type="radio"]'
  );

  let selected = [...colorOptions].some(opt => opt.checked);

  if(!selected){
    colorError.style.display="block";
    return;
  }

  colorError.style.display="none";
  festivalColorStep.style.display="none";
  accessoriesStep.style.display="block";

});

colorBackBtn?.addEventListener("click",()=>{
  festivalColorStep.style.display="none";
  festivalModal.style.display="block";
});

accessoryNextBtn?.addEventListener("click",()=>{
  let selected=[...accessoryOptions].some(opt=>opt.checked);
  if(!selected){ accessoryError.style.display="block"; return; }
  accessoriesStep.style.display="none";
  maritalStep.style.display="block";
});

accessoryBackBtn?.addEventListener("click",()=>{
  accessoriesStep.style.display="none";
  festivalColorStep.style.display="block";
});

maritalNextBtn?.addEventListener("click",()=>{
  let selectedRadio = document.querySelector('#festivalMaritalStep input[type="radio"]:checked');
  if(!selectedRadio){ maritalError.style.display="block"; return; }

  let value = selectedRadio.value;
  maritalStep.style.display="none";

  if(value === "Do not prefer"){
    shopStep.style.display="block";
  }else{
    anniversaryBlock.style.display = value === "Married" ? "flex" : "none";
    dayDateStep.style.display="block";
loadFlatpickr();
  }
});

maritalBackBtn?.addEventListener("click",()=>{
  maritalStep.style.display="none";
  accessoriesStep.style.display="block";
});

// dateNextBtn?.addEventListener("click",()=>{
//   let valid = true;

//   if (!dobInput.value){ dobError.style.display="block"; valid=false; } else dobError.style.display="none";
//   if (anniversaryBlock.style.display !== "none" && !anniversaryInput.value){ anniversaryError.style.display="block"; valid=false; } else anniversaryError.style.display="none";
//   if (!locationSelect.value){ locationError.style.display="block"; valid=false; } else locationError.style.display="none";

//   if (!valid) return;

//   dayDateStep.style.display="none";
//   shopStep.style.display="block";
// });
dateNextBtn?.addEventListener("click", () => {

  let valid = true;

  if (!dobInput.value){ dobError.style.display="block"; valid=false; } else dobError.style.display="none";
  if (anniversaryBlock.style.display !== "none" && !anniversaryInput.value){ anniversaryError.style.display="block"; valid=false; } else anniversaryError.style.display="none";
  if (!locationSelect.value){ locationError.style.display="block"; valid=false; } else locationError.style.display="none";

  if (!valid) return;

  dayDateStep.style.display="none";
  shopStep.style.display="block";
});

dateBackBtn?.addEventListener("click",()=>{
  dayDateStep.style.display="none";
  maritalStep.style.display="block";
});

shopNextBtn?.addEventListener("click",()=>{
  let selected = [...shopOptions].some(opt => opt.checked);
  if(!selected){ shopError.style.display="block"; return; }

  shopStep.style.display="none";
  silhouetteStep.style.display="block";
});

shopBackBtn?.addEventListener("click",()=>{
  shopStep.style.display="none";

  let selectedRadio = document.querySelector('#festivalMaritalStep input[type="radio"]:checked');
  if(selectedRadio && selectedRadio.value === "Do not prefer"){
    maritalStep.style.display="block";
  }else{
    dayDateStep.style.display="block";
loadFlatpickr();
  }
});

silhouetteNextBtn?.addEventListener("click",()=>{
  let selected=[...silhouetteOptions].some(opt=>opt.checked);
  if(!selected){ silhouetteError.style.display="block"; return; }

  silhouetteStep.style.display="none";
  usuallyShopStep.style.display="block";
});

silhouetteBackBtn?.addEventListener("click",()=>{
  silhouetteStep.style.display="none";
  shopStep.style.display="block";
});

usuallyNextBtn?.addEventListener("click",()=>{
  let selected=[...usuallyOptions].some(opt=>opt.checked);
  if(!selected){ usuallyError.style.display="block"; return; }

  usuallyShopStep.style.display="none";
  festivalCompleteStep.style.display="block";
});

usuallyBackBtn?.addEventListener("click",()=>{
  usuallyShopStep.style.display="none";
  silhouetteStep.style.display="block";
});




function buildFilterURL(profileData){

  const baseUrl = "/collections/test-collection";
  const params = new URLSearchParams();

  /* FESTIVALS */
  if(profileData.festival && profileData.festival.length){
    profileData.festival
      .filter(f => f !== "Other")
      .forEach(festival=>{
        params.append("filter.p.m.custom.festivals", festival);
      });
  }

  /* COLORS */
  if(profileData.color && profileData.color.length){
    profileData.color.forEach(color=>{
      params.append("filter.p.m.magento.confi_color", color);
    });
  }

  /* SORT */
  params.append("sort_by","manual");

  return baseUrl + "?" + params.toString();
}
/* ---------------- SAVE PROFILE ---------------- */

startShoppingBtn?.addEventListener("click", function(e){

  e.preventDefault();

  /* SHOW LOADER */
  profileLoader.style.display = "flex";

  const profileData = {
    email: window.customerData?.email || "",
    festival: [...allCheckboxes].filter(cb=>cb.checked).map(cb=>cb.value),
    color: [...document.querySelectorAll('input[name="profile_color"]:checked')]
      .map(el => el.value),
    accessory: document.querySelector('#festivalAccessoriesStep input[type="radio"]:checked')?.value || "",
    marital: document.querySelector('#festivalMaritalStep input[type="radio"]:checked')?.value || "",
    dob: dobInput.value,
    anniversary: anniversaryInput.value,
    location: locationSelect.value,
    shopFor: [...shopOptions].filter(opt=>opt.checked).map(opt=>opt.value),
    silhouette: document.querySelector('#festivalSilhouetteStep input[type="radio"]:checked')?.value || "",
    usuallyShop: document.querySelector('#usuallyShopStep input[type="radio"]:checked')?.value || ""
  };

  const noteField = document.getElementById("customerNoteField");
  const noteForm = document.getElementById("customerNoteForm");

  if(noteField && noteForm){

    startShoppingBtn.disabled = true;
    startShoppingBtn.textContent = "Saving...";

    fetch("https://script.google.com/macros/s/AKfycby5ZuRAOWt5qqPLJB0avtp19kOOODGKp3rPtpz470Me-zQWsXud05w_GZvMUBM4XAZe/exec", {
      method: "POST",
      body: JSON.stringify(profileData),
      mode: "no-cors"
    })
    .then(() => {

      console.log("Saved to Google Sheet");

      /* Save to Shopify customer note */
      noteField.value = JSON.stringify(profileData);
      noteForm.submit();

      /* BUILD FILTER URL */
      const filterURL = buildFilterURL(profileData);

      /* REDIRECT TO COLLECTION */
      setTimeout(()=>{
        window.location.href = filterURL;
      },1000);

    })
    .catch(err => {

      console.error("Error saving", err);

      /* HIDE LOADER */
      profileLoader.style.display = "none";

      startShoppingBtn.disabled = false;
      startShoppingBtn.textContent = "Start Shopping";

    });

  }

});

/* ---------------- AUTO HIDE ERRORS ---------------- */

[shopOptions, silhouetteOptions].forEach(group=>{
  group.forEach(opt=>{
    opt.addEventListener("change", hideErrors);
  });
});


function getSelectedFestivals(){
  return [...document.querySelectorAll('#festivalStep input[type="checkbox"]:checked')]
    .map(cb => cb.value);
}


function loadFestivalColors(){

  const festivals = getSelectedFestivals();
  const container = document.getElementById("dynamicColorList");

  if(!container) return;

  container.innerHTML = '<p class="loadingcolor">Loading colors...</p>';

  /* STEP 1 — URL with festival filters */
  let url = "/collections/test-collection?section_id=main-collection-product-grid";

  festivals.forEach(festival=>{
    url += "&filter.p.m.custom.festivals=" + encodeURIComponent(festival);
  });

  fetch(url)
  .then(res => res.text())
  .then(html => {

    let doc = new DOMParser().parseFromString(html,"text/html");

    let inputs = doc.querySelectorAll('input[name="filter.p.m.magento.confi_color"]');

    /* STEP 2 — If no colors found → load all collection colors */
    if(inputs.length === 0){

      console.log("Festival has no products → loading all collection colors");

      return fetch("/collections/test-collection?section_id=main-collection-product-grid")
        .then(res => res.text());
    }

    return html;

  })
  .then(html => {

    const doc = new DOMParser().parseFromString(html,"text/html");

    const inputs = doc.querySelectorAll('input[name="filter.p.m.magento.confi_color"]');

    const colors = new Set();

    inputs.forEach(input=>{
      if(input.value){
        colors.add(input.value.trim());
      }
    });

    container.innerHTML = "";

    if(colors.size === 0){
      container.innerHTML = "<p>No colors found</p>";
      return;
    }

    colors.forEach(color=>{

      const swatch = window.metaSwatches
        ? window.metaSwatches[color.toLowerCase()]
        : null;

      const label = document.createElement("label");
      label.className = "color-item";

      let swatchHTML = "";

      if(swatch?.image){
        swatchHTML = `<img class="swatch-img" src="${swatch.image}" alt="${color}">`;
      }
      else if(swatch?.hex){
        swatchHTML = `<span class="color-circle" style="background:${swatch.hex};"></span>`;
      }
      else{
        swatchHTML = `<span class="color-circle"></span>`;
      }

      label.innerHTML = `
        <input type="checkbox" name="profile_color" value="${color}">
        <span>${swatchHTML}</span>
      `;

      container.appendChild(label);

    });

  })
  .catch(err=>{
    console.error("Color load error:", err);
    container.innerHTML = "<p>Unable to load colors</p>";
  });

}


/* ---------------- AUTO OPEN AFTER LOGIN ---------------- */

let profileOpenedOnce = false;

function checkLoginAndOpen(){

  if (profileOpenedOnce) return;

  if (!sessionStorage.getItem("openProfileAfterLogin")) return;

  if (window.customerData && window.customerData.loggedIn){

    profileOpenedOnce = true; // ✅ prevent repeat

    sessionStorage.removeItem("openProfileAfterLogin");

    setTimeout(() => {
      modal.classList.add("active");
      document.body.classList.add("modal-open");

      resetAll();
    }, 500); // 🔥 wait for Shopify DOM settle

  } else {
    setTimeout(checkLoginAndOpen, 500);
  }
}

window.addEventListener("load", function(){
  checkLoginAndOpen();
});



});




